module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("ILLUSTRATIONS")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("MAPS")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#p59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Abraham’s wanderings")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#p81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Exodus route")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#p135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Borders of Canaan")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("FIGURES")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#p33"
    }
  }, [_vm._v("1 Ziggurat")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#p62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Adam’s family tree")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#p91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The tabernacle")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#p108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Cleanness rules")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#p120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Arrangement of material in Exodus in relation to Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#p121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Israel in camp")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#p122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Israel on the march")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#p127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Scalloped loincloth")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#p149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Phylactery")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#p183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The documentary hypothesis")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("TABLES")]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#tab-002"
    }
  }, [_vm._v("Parallels between the Sumerian flood story and Genesis 1—9")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#tab-003"
    }
  }, [_vm._v("Internal titles in the book of Genesis")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#tab-004"
    }
  }, [_vm._v("Creation")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#tab-008"
    }
  }, [_vm._v("Genealogies of Adam to Noah")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#tab-009"
    }
  }, [_vm._v("Creation before and after the flood")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#tab-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Genesis 12—50")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#tab-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrangement of the story of Jacob")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#tab-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrangement of the story of Joseph")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#tab-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The plagues")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifices: An overview")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cleanness rules")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spectrum of conditions from holy to unclean")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grades of uncleanness")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Festivals")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#tab-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifices: An overview (completed)")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two halves of Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels between Exodus and Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scenes in the Balaam story")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further parallels between Exodus and Numbers")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal sacrifices")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#tab-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy’s structure as a cross between a law code and a treaty")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#tab-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Structure of the second sermon")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#tab-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy’s application of the Ten Commandments")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Astruc’s analysis of Genesis 1—11")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identification of sources")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Documentary hypothesis")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dating of sources")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Characteristics of different eras and sources")])]), _c('p', {
    staticClass: "txt_courant retrait_ligne2etsuivantes"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap9#tab-042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deuteronomy in parallel with Hittite and Assyrian treaties")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0